import BusinessTripImposition from '@/components/master/BusinessTripImposition'
import BusinessTripImpositionDetail from '@/components/master/BusinessTripImpositionDetail'
import BusinessTripImpositionNew from '@/components/master/BusinessTripImpositionNew'

const businessTripImpositionRouter = [
  {
    path: 'master/business-trip-imposition',
    name: 'business-trip-imposition',
    component: BusinessTripImposition
  },
  {
    path: 'master/business-trip-imposition/new',
    name: 'business-trip-imposition-new',
    component: BusinessTripImpositionNew
  },
  {
    path: 'master/business-trip-imposition/:id',
    name: 'business-trip-imposition-detail',
    component: BusinessTripImpositionDetail
  }
]

export default businessTripImpositionRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripImpositionRouter.js